angular.module("groups")

    .controller("AttendedEventsPositionsModalCtrl", ['LoginService', '$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', 'position_id', 'group_id', '$http', 'treeService', '$uibModal', 'gridService', '$q', '$interval', '$timeout', 'uiGridConstants', function (LoginService, $scope, $uibModalInstance, Restangular, modalService, $filter, position_id, group_id, $http, treeService, $uibModal, gridService, $q, $interval, $timeout, uiGridConstants) {

        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("GROUPS_WRITE");

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        var position = (position_id != null ? true : false);

        var columnDefs = [];
        if (position) {
            columnDefs.push({ name: 'id', visible: false, exporterSuppressExport: true },
                {
                    name: 'date', field: 'FK_events_guests_events.date_from', displayName: $filter('translate')('persons.date'),
                    type: 'date', cellFilter: 'toLocalDate | date:\'dd/MM/yyyy\'', enableColumnMenu: false, enableFiltering: false, width: 100,
                    customFormatFn: function (value) {
                        if (value != null) {
                            var fecha = new Date(value);
                            return $filter('date')(fecha, 'dd/MM/yyyy');
                        }
                        return "";
                    },
                },
                { name: 'event_name', field: 'FK_events_guests_events.name', displayName: $filter('translate')('persons.event_name'), enableColumnMenu: false, enableFiltering: true, enableHiding: false },
                {
                    name: 'name', field: 'FK_events_guests_persons.name', displayName: $filter('translate')('persons.name'), enableColumnMenu: false, enableFiltering: false, enableHiding: false,
                    cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.FK_events_guests_persons.name}} {{row.entity.FK_events_guests_persons.surname}}</div>'
                },
                {
                    name: 'confirmation_status', displayName: $filter('translate')('events.guests.status'), enableColumnMenu: false, enableFiltering: false, enableHiding: false, width: 100,
                    cellTemplate: '<div class="ui-grid-cell-contents" ng-if="row.entity.confirmation_status === \'pending\'"><span style="display:block; height: 19px;" class="label label-warning">{{\'events.guests.pending\' | translate}}<span></div>' +
                        '<div class="ui-grid-cell-contents" ng-if="row.entity.confirmation_status === \'confirmed\'"><span style="display:block; height: 19px;" class="label label-primary">{{\'events.guests.confirmed\' | translate}}<span></div>' +
                        '<div class="ui-grid-cell-contents" ng-if="row.entity.confirmation_status === \'delegated\'"><span style="display:block; height: 19px;" class="label label-information">{{\'events.guests.delegated\' | translate}}<span></div>' +
                        '<div class="ui-grid-cell-contents" ng-if="row.entity.confirmation_status === \'rejected\'"><span style="display:block; height: 19px;" class="label label-danger">{{\'events.guests.rejected\' | translate}}<span></div>',
                    customFormatFn: function (value) {
                        if (value != null) {
                            return $filter('translate')('events.guests.' + value);
                        }
                        return "";
                    },
                });
        } else {
            columnDefs.push({ name: 'id', visible: false, exporterSuppressExport: true },
                {
                    name: 'date', field: 'FK_events_guests_events.date_from', displayName: $filter('translate')('persons.date'),
                    type: 'date', cellFilter: 'toLocalDate | date:\'dd/MM/yyyy\'', enableColumnMenu: false, enableFiltering: false, width: 100,
                    customFormatFn: function (value) {
                        if (value != null) {
                            var fecha = new Date(value);
                            return $filter('date')(fecha, 'dd/MM/yyyy');
                        }
                        return "";
                    },
                },
                { name: 'event_name', field: 'FK_events_guests_events.name', displayName: $filter('translate')('persons.event_name'), enableColumnMenu: false, enableFiltering: true, enableHiding: false },
                { name: 'FK_events_guests_positions.FK_positions_tl_positions.name', field: 'FK_events_guests_positions.FK_positions_tl_positions[0].name', displayName: $filter('translate')('persons.event_name'), enableColumnMenu: false, enableFiltering: false, enableHiding: false },
                { name: 'total_guests', field: 'total_guests', displayName: $filter('translate')('events.guests.guests'), enableColumnMenu: false, enableFiltering: false, enableHiding: false }
                );
        }

    /* GRIDS */
    $scope.gridAttendedEvents = {
        pdfTitle: $filter('translate')('persons.attended_events'),
        exporterCsvFilename: $filter('translate')('persons.attended_events') + ".csv",
        exporterExcelFilename: $filter('translate')('persons.attended_events') + ".xlsx",
        exporterMenuCsv: true,
        exporterCsvColumnSeparator: ';',
        enableGridMenu: true,
        gridMenuShowHideColumns: false,
        paginationPageSizes: [10, 20, 30],
        paginationPageSize: 10,
        onRegisterApi: function (gridApi) {
            this.gridApi = gridApi;
        },
        columnDefs: columnDefs,
        getData: function (options) {
            if (position) {
                options.position_id = position_id;
                return Restangular.all('Positions/AttendedEvents').getList(options);
            } else {
                options.group_id = group_id;
                return Restangular.all('Groups/AttendedEvents').getList(options);
            }
        }
    };


}])
;